<template>
  <div class="t-page_user t-work-area">
    <h1>{{ user.name }}</h1>
    <div class="t-work-area__row">
      <div class="t-work-area__column_small">
        <div class="t-work-area__cell">
          <img class="t-teacherItem__img" :src="user.img" v-if="user.img !== ''">
          <img class="t-teacherItem__img" src="/img/default_img.png" v-else>
          <div class="t-teacherItem__address" v-if="user.location !== ''">{{ user.location }}</div>
          <div class="t-teacherItem__age" v-if="user.date !== ''">{{ user.date }}</div>
          <div class="t-teacherItem__footer">
            <cmp-rating :rate="user.rate" size="small"></cmp-rating>
            <div class="t-teacherItem__reviews">{{ user.reviews_count }} {{ declOfNum }}</div>
          </div>
          <router-link class="t-btn t-page_user__btn-dialog" :to="{name: 'dialog', query: {userId: user.id}}"
                      v-if="user.openDialog && !user.himself"><span>{{ pageText.sendMessage }}</span></router-link>

          <template v-if="hasAuth && !user.himself">
            <hr class="_horizontal">
            <button class="t-black-list-link" v-if="!user.blackList" @click.prevent="BlackList(true)">{{
              pageText.addBlackList }}
            </button>
            <button class="t-black-list-link _delete" @click.prevent="BlackList(false)" v-else>{{
              pageText.delBlackList }}
            </button>
          </template>
          <template v-if="hasAuth && !user.himself">
            <hr class="_horizontal">
            <button class="t-black-list-link" @click.prevent="modalDialogType_reportOpen({id: user.id})">
              {{pageText.report }}
            </button>
          </template>
        </div>
      </div>
      <div class="t-work-area__column_big">
        <div class="t-work-area__cell t-default">
          <h2>{{ pageText.title }}</h2>
          <div class="t-userContacts">
            <p v-for="(contact, index) in user.contacts" class="t-userContacts__item" :key="index">
              {{ contact.title }}
                <span>
                  <a v-if="contact.type == 'social'" :href=" contact.value.split('/')[0] == 'https:'?contact.value:'https://'+contact.value" target="_blank" >
                    @{{ contact.value.split('/')[contact.value.split('/').length -1] }}
                  </a>
                  <a v-else-if="contact.type == 'phone'" :href="'tel:+'+contact.value" >
                    {{ contact.value }}
                  </a>
                  <a v-else-if="contact.type == 'email'" :href="'mailto:+'+contact.value" >
                    {{ contact.value }}
                  </a>
                  <a v-else-if="contact.type == 'skype'" :href="'skype:'+contact.value" >
                    {{ contact.value }}
                  </a>
                  <a v-else-if="contact.type == 'telegram'" :href="'tg://resolve?domain='+contact.value" >
                    {{ contact.value }}
                  </a>
                  <a v-else :href="contact.value " target="_blank" rel="noopener noreferrer">
                    {{ contact.value }}
                  </a>
                </span>
              <template v-if="contact.main">({{ pageText.main }})</template>
            </p>
          </div>
          <template v-if="about !== ''">
            <h3>{{ pageText.about }}</h3>
            <p v-html="about" class="t-userContacts__styled"></p>
          </template>
          <template v-if="education !== ''">
            <h3>{{ pageText.education }}</h3>
            <p v-html="education" class="t-userContacts__styled"></p>
          </template>
          <template v-if="experience !== ''">
            <h3>{{ pageText.experience }}</h3>
            <p v-html="experience" class="t-userContacts__styled"></p>
          </template>
          <template v-if="user.topics && (user.topics.length > 0)">
            <h3>{{ pageText.topics }}</h3>
            <p>
              <template v-for="(item, index) in user.topics">
                {{ item.label }}<template v-if="(index + 1) < user.topics.length">, </template>
              </template>
            </p>
          </template>
          <template v-if="user.language && ( user.language.length > 0 )">
            <h3>{{ pageText.language }}</h3>
            <p>
              <template v-for="(item, index) in user.language">
                {{ item.label }}<template v-if="(index + 1) < user.language.length">, </template>
              </template>
            </p>
          </template>
          <template v-if="video.video_link !== ''">
            <h2>{{ pageText.video }}</h2>
            <div class="t-userVideo" v-if="video.video_type === 'youtube'">
              <iframe width="820" height="470"
                      :src="'https://www.youtube.com/embed/' + video.video_link + '?rel=0&amp;controls=1&amp;showinfo=0'"
                      frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
            <div class="t-userVideo" v-if="video.video_type === 'vimeo'">
              <iframe :src="'https://player.vimeo.com/video/' + video.video_link + ''" width="820"
                      height="470" frameborder="0" webkitallowfullscreen mozallowfullscreen
                      allowfullscreen></iframe>
            </div>
          </template>
          <template v-if="user.documents && user.documents.length">
            <cmp-documents :pageText="pageText" :isProfile="false"></cmp-documents>
          </template>
        </div>
        <div class="t-courses_user t-courses">
          <h2 class="t-courses_user-title">{{ pageText.lessons }}</h2>

          <div class="t-coursesList__wrap">
            <cmp-course :data="item" v-for="(item, index) in user.courses" :key="index"></cmp-course>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    let localeText = {
        url: process.env.NODE_ENV !== 'production' ? 'staticText/userPage.json' : 'staticText',
        main: {
            title: "Мои данные",
            about: "О себе",
            knowledge: "Интересующие области знаний",
            topics: "Интересующие темы",
            language: "Язык обучения",
            video: "Видео",
            documents: "Документы, сертификаты и дипломы",
            lessons: "Опубликованные уроки и курсы",
            main: "предпочтительный",
            sendMessage: "Написать сообщение",
            addBlackList: "Добавить в черный список",
            report: "Сообщить о нарушении",
            education: "Образование",
            experience: "Опыт работы",
            delBlackList: "Удалить из черного списка",
            msgSuccessAdd: "Пользователь добавлен в черный список",
            msgSuccessDelete: "Пользователь удален из черного списка"
        }
    };

    import {store} from '../../store'

    import {mapActions, mapGetters} from 'vuex';

    import Course from '../../vue_components/Course.vue'
    import Rating from '../../vue_components/Rating.vue'
    import Documents from '../../vue_components/Documents.vue'

    export default {
        data() {
            return {
                pageText: {}
            }
        },
        components: {
            'cmp-course': Course,
            'cmp-rating': Rating,
            'cmp-documents': Documents
        },
        computed: {
            ...mapGetters('staticText', ['reviewsCountArr']),
            ...mapGetters('user', ['user']),
            ...mapGetters('profile', ['hasAuth']),
            declOfNum() {
                let cases = [2, 0, 1, 1, 1, 2];

                return this.reviewsCountArr[(this.user.reviews_count % 100 > 4 && this.user.reviews_count % 100 < 20) ? 2 : cases[(this.user.reviews_count % 10 < 5) ? this.user.reviews_count % 10 : 5]];
            },
            video() {
                let video = {
                    video_link: '',
                    video_type: ''
                };
                if(this.user.video ) {
                  if (this.user.video !== '') {
                      if (this.user.video.indexOf('youtube') >= 0 || this.user.video.indexOf('youtu.be') >= 0) {
                          video.video_type = 'youtube';
                          video.video_link = this.user.video.split('?v=')[1];

                          if (!video.video_link){
                              video.video_link = this.user.video.split('youtu.be/')[1];
                          }
                          video.video_link = video.video_link.split('&')[0];
                      }
                      if (this.user.video.indexOf('vimeo') >= 0) {
                          video.video_type = 'vimeo';
                          let index = data.video.lastIndexOf('/') + 1;
                          video.video_link = this.user.video.substring(index, this.user.video.length);
                      }
                  }
                }
                return video
            },
            about() {
                let div = document.createElement("div");
                div.innerHTML = this.user.about;
                let text = div.textContent || div.innerText || "";
                let replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
                let replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
                let replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
                let replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

                return replacedText;
            },
            education() {
                let div = document.createElement("div");
                div.innerHTML = this.user.education;
                let text = div.textContent || div.innerText || "";
                let replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
                let replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
                let replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
                let replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

                return replacedText;
            },
            experience() {
                let div = document.createElement("div");
                div.innerHTML = this.user.experience;
                let text = div.textContent || div.innerText || "";
                let replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
                let replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
                let replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
                let replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

                return replacedText;
            }
        },
        watch: {
          hasAuth(){
            if(this.hasAuth){
              this.LoadUserInfo(this.$route.params.url);
            }
          }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('user', ['LoadUserInfo']),
            ...mapActions('msg', ['showMsg']),
            ...mapActions('modal', ['modalDialogType_reportOpen']),
            Load(pageText) {
                this.pageText = pageText;
                setTimeout(() => {
                    this.UpdatePreloadState(false);
                }, 500)
            },
            BlackList(e) {
                if (e) {
                    let fd = new FormData();
                    fd.append('id', this.user.id);

                    this.$http.post('profile/blackList', fd)
                        .then(response => {
                            if (response.body.success) {
                                this.LoadUserInfo(this.$route.params.url);
                                this.showMsg(this.pageText.msgSuccessAdd);
                            } else {
                                let error_text = [];

                                for (let key in response.body.errors) {
                                    error_text.push(response.body.errors[key].join(', '));
                                }

                                this.showMsg(error_text.join(', '));
                            }
                        }, response => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                            this.login_edit = false;
                            this.login.value = this.user.login
                        });
                } else {
                    this.$http.delete('profile/blackList/' + this.user.id)
                        .then(response => {
                            if (response.body.success) {
                                this.LoadUserInfo(this.$route.params.url);
                                this.showMsg(this.pageText.msgSuccessDelete);
                            } else {
                                let error_text = [];

                                for (let key in response.body.errors) {
                                    error_text.push(response.body.errors[key].join(', '));
                                }

                                this.showMsg(error_text.join(', '));
                            }
                        }, response => {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже');
                            this.login_edit = false;
                            this.login.value = this.user.login
                        });
                }
            }
        },
        beforeRouteLeave(to, from, next) {
            this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter(to, from, next) {
            let count = 0;

            let pageText = {};

            store.dispatch('staticText/LoadDocumentsText').then(() => {
                count++;
                RunNext();
            });

            store.dispatch('staticText/LoadPageText', localeText).then((data) => {
                pageText = data;

                count++;
                RunNext();
            });
            store.dispatch('user/LoadUserInfo', to.params.url).then((e) => {
                if (e) {
                    count++;
                    RunNext();
                } else {
                    next({
                        name: 'E404'
                    })
                }
            });

            let RunNext = () => {
                if (count > 2) {
                    next(vm => vm.Load(pageText))
                }
            }
        }
    }
</script>

<style lang="sass">
  .t-page_user
    .t-courses_user
      margin: 32px 0 0
      &-title
        margin-bottom: 24px
      .t-courseItem
        margin: 0 12px 41px !important
    .t-page_user__btn-dialog
      display: block !important
      margin-top: 24px !important
    .t-userContacts
      margin: 0 0 32px
      &__styled
        a
          color: #52a8f2
      &__item
        margin: 0 0 8px !important
        display: flex
        align-items: flex-end
        line-height: 1.2
        span
          color: $blue
          font-weight: bold
          margin: 0 8px
        &:last-child
          margin-bottom: 0
    .t-userVideo
      width: 820px
      max-width: 100%
      position: relative
      padding-bottom: 52.456%
      margin: 0 0 32px
      border-radius: 16px
      overflow: hidden
      iframe
        position: absolute
        top: 0
        left: 0
        width: 100% !important
        height: 100% !important
    .t-userDocuments
      &__item
        display: flex
        align-items: center
        margin: 0 0 16px
        &:last-child
          margin-bottom: 0
        svg
          margin-right: 16px
        p
          font-weight: bold
          margin: 0 !important
        span
          font-weight: normal
          display: block
          color: $grey
          font-size: 14px
</style>



// WEBPACK FOOTER //
// src/vue_pages/User/Index.vue